export function converterParaNumeroAmericano(valorBrasileiro: string) {
  const semPontoMilhar = valorBrasileiro?.replace(/\./g, "");
  const numeroAmericano = semPontoMilhar?.replace(",", ".");
  return parseFloat(numeroAmericano);
}

export function converterParaNumeroBrasileiro(valorAmericano: number) {
  const valorString = valorAmericano?.toFixed(2).toString();
  const partes = valorString?.split(".");
  const parteInteira = partes[0]?.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  return parteInteira + "," + partes[1];
}
